import {Component, Input, OnInit} from '@angular/core';
import {ImageDisplay, MxCreativeTypeService, PromoLightMxObj, TopZoneMxObj} from 'mx-core';
import {Router} from '@angular/router';
import {PrlMarketingToolsService} from '../../../prl-marketing-tools/services/prl-marketing-tools.service';
import {ZoneLightPrlObj} from '../../../../../../generated/generated.model';
import {
    PrlGenerateCodeComponent
} from '../../../prl-marketing-tools/components/prl-generate-code/prl-generate-code.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'prl-dashboard-top-zone',
    templateUrl: './prl-dashboard-top-zone.component.html',
    standalone: false,
    styleUrls: ['./prl-dashboard-top-zone.component.scss']
})
export class PrlDashboardTopZoneComponent implements OnInit {

    @Input()
    zone: TopZoneMxObj;

    protected lightZone: ZoneLightPrlObj;

    type: string;
    images: ImageDisplay[];
    public creatives: PromoLightMxObj[] = new Array<PromoLightMxObj>();

    constructor(private readonly dialog: MatDialog,
                private readonly marketingToolsService: PrlMarketingToolsService,
                protected router: Router) {
    }

    ngOnInit(): void {
        this.marketingToolsService.getLightZone(this.zone.zoneId).subscribe(lightZone =>
            this.lightZone = lightZone
        );
        this.creatives.push(...this.zone.promos);
        this.type = this.zone.promo.typeName;
        this.images = this.zone.promos.map(promo => {
           return promo.thumbContent
               ? new ImageDisplay(promo.thumbContent)
               : new ImageDisplay(this.getDefaultThumbnailClass(this.type), true);
        });
    }

    getDefaultThumbnailClass(type: string): string {
        return MxCreativeTypeService.getDefaultThumbnailClass(type);
    }

    openGenerateCode(zone: ZoneLightPrlObj) {
        if (!zone) {
            return;
        }
        this.dialog.open(PrlGenerateCodeComponent, {
            width: '80%',
            panelClass: 'mx-dialog-panel-class',
            data: {
                zone
            }
        }).afterClosed();
    }
}
